import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CookieService } from "ngx-cookie-service";
import { Subject } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { ApiService } from "src/app/services/api";
import { AlertService } from "./AlertService/alert.service";
@Injectable({
  providedIn: "root",
})
export class DeviceService {
  token = this.cookieService.get("token");
  storeId = this.cookieService.get("storeId");
  merchantId = this.cookieService.get("merchantId");
  isLoadingChangeSub = new Subject<boolean>();

  GLOBALURL: String = this.ApiService.getBaseURL();
  constructor(
    private http: HttpClient,
    private router: Router,
    private cookieService: CookieService,
    private toastr: AlertService,
    private ApiService: ApiService,
    private modalService: NgbModal
  ) {
    this.GLOBALURL = this.ApiService.getBaseURL();
  }

  uploadImage(deviceType, formData) {
    return this.http.put(
      `${this.GLOBALURL}/upload?path=images/${deviceType}/`,
      // `${this.GLOBALURL}/uploadVideo`,
      formData,
      {
        headers: new HttpHeaders({
          enctype: "multipart/form-data",
          // "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
      }
    );
  }

  uploadImage2(deviceType, formData) {
    return this.http.put(
      `${this.GLOBALURL}/uploadVideo`,
      formData,
      {
        headers: new HttpHeaders({
          enctype: "multipart/form-data",
          // "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
      }
    );
  }

  uploadDeviceImage(deviceType, formData) {
    return this.http.put(
      `${this.GLOBALURL}/upload?path=images/${deviceType}/`,
      formData,
      {
        headers: new HttpHeaders({
          enctype: "multipart/form-data",
          // "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
      }
    );
  }


  addNewDevice(newDevicePayload) {
    this.isLoadingChangeSub.next(true);
    return this.http
      .post(this.GLOBALURL + "/device", newDevicePayload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
      })
      .subscribe(
        (response: any) => {
          if (response.success === 0) {
            this.isLoadingChangeSub.next(false);
            this.toastr.error(response.message);
          } else if (!response.error) {
            if (this.modalService.hasOpenModals()) {
              console.log("MODAL_OPEN");
              this.isLoadingChangeSub.next(false);
              const department = response.response;
              this.modalService.dismissAll( department );
              this.toastr.clear();
              this.toastr.success(response.message);
              return
            }
            this.isLoadingChangeSub.next(false);
            this.toastr.success(response.message);
            this.router.navigate(["/hardware/hardware"]);
          }
        },
        (error) => {
          const message = this.ApiService.errorMessage(error)
          this.toastr.clear();
          this.toastr.error(message);
          this.isLoadingChangeSub.next(false);
        }
      );
  }

  addDevice(newDevicePayload) {
    this.isLoadingChangeSub.next(true);
    return this.http
      .post(this.GLOBALURL + "/device", newDevicePayload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
      })
  }

  updateDevice(devicePayload) {
    this.isLoadingChangeSub.next(true);
    return this.http
      .put(this.GLOBALURL + "/device", devicePayload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
      })
      .subscribe(
        (response: any) => {
          if (response.success === 0) {
            this.isLoadingChangeSub.next(false);
            this.toastr.error(response.message);
            console.log("failed");
          } else if (!response.error) {
            this.isLoadingChangeSub.next(false);
            this.toastr.success(response.message);
            //this.router.navigate(["/hardware/hardware"]);
          }
        },
        (error) => {
          const message = this.ApiService.errorMessage(error)
          this.toastr.clear();
          this.toastr.error(message);
          this.isLoadingChangeSub.next(false);
        }
      );
  }

  _updateDevice(devicePayload) {
    this.isLoadingChangeSub.next(true);
    return this.http
      .put(this.GLOBALURL + "/device", devicePayload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
      })
  }

  reassignDevice(devicePayload) {
    this.isLoadingChangeSub.next(true);
    return this.http
      .put(this.GLOBALURL + "/device/reassign", devicePayload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
      })
  }

  updateDeviceNoLoad(devicePayload) {
    return this.http
      .put(this.GLOBALURL + "/device", devicePayload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
      })
      .subscribe((response: any) => {
        if (response.success === 0) {
          this.toastr.error(response.message);
        } else if (!response.error) {
          this.toastr.success(response.message);
          //this.router.navigate(["/hardware/hardware"]);
        }
      });
  }

  getDeviceByDeviceId(deviceId) {
    return this.http
      .get(this.GLOBALURL + "/device", {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        }),
        params: new HttpParams()
          .set("deviceId", deviceId)
          .set("storeId", this.storeId)
          .set("merchantId", this.merchantId),
      })
      .pipe(shareReplay(1));
  }

  unarchiveDeviceById(payload) {
    return this.http.patch(this.GLOBALURL + "/device", payload, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      }),
    });
  }

  permanentlyDeleteDeviceById(deviceIds) {
    return this.http.delete(this.GLOBALURL + "/device", {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      }),
      params: {
        deviceId: deviceIds,
        isPermanent: '1'
      },
    });
  }

  deleteDeviceById(deviceIds) {
    return this.http.delete(this.GLOBALURL + "/device", {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.cookieService.get("token"),
      }),
      params: {
        deviceId: deviceIds,
      },
    });
  }

  deviceStatusUpdate(devicePayload) {
    return this.http.put(
      this.GLOBALURL + "/device/toggleActive",
      devicePayload,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
      }
    );
  }

  getAllDevice() {
    let merchantId = this.cookieService.get("merchantId");
    let storeId = this.cookieService.get("storeId");
    return this.http
      .get(this.GLOBALURL + "/device", {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
        params: {
          storeId: storeId,
        },
      })
      .pipe(shareReplay(1));
  }

  getAllDeviceByStoreID() {
    let merchantId = this.cookieService.get("merchantId");
    let storeId = this.cookieService.get("storeId");
    return this.http
      .get(this.GLOBALURL + "/device", {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
        params: {
          storeId: storeId,
        },
      })
      .pipe(shareReplay(1));
  }

  getDevicesByType(deviceType: number) {
    return this.http
      .get(this.GLOBALURL + "/device", {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
        params: {
          storeId: this.cookieService.get("storeId"),
          merchantId: this.cookieService.get("merchantId"),
          deviceType: deviceType,
        },
      })
      .pipe(shareReplay(1));
  }

  getNextDevicesByType(deviceType: number, offset: number) {
    return this.http
      .get(this.GLOBALURL + "/device", {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
        params: new HttpParams()
          .set("storeId", this.cookieService.get("storeId"))
          .set("merchantId", this.cookieService.get("merchantId"))
          .set("deviceType", deviceType)
          .set("offset", offset),
      })
      .pipe(shareReplay(1));
  }

  getDevices(deviceType: number) {
    return this.http
      .get(this.GLOBALURL + "/device", {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
        params: new HttpParams()
          .set("storeId", this.cookieService.get("storeId"))
          .set("merchantId", this.cookieService.get("merchantId"))
          .set("deviceType", deviceType)
          .set("limit", 0)
      })
      .pipe(shareReplay(1));
  }

  // getAllStore() {
  //   var merchantId = this.cookieService.get('merchantId');
  //   return this.http.get(
  //     this.GLOBALURL + "/store?merchantId="+merchantId,
  //     {
  //       headers: new HttpHeaders({
  //         "Content-Type": "application/json",
  //         Authorization: this.cookieService.get("token"),
  //       }),
  //     }
  //   );
  // }

  updateImage(imagePayload) {
    return this.http.put(
      this.GLOBALURL + "/upload?path=images/cfd/",
      imagePayload,
      {
        headers: new HttpHeaders({
          enctype: "multipart/form-data",
          Authorization: this.cookieService.get("token"),
        }),
      }
    );
  }
}
